import React from 'react';
import Select, { Props } from 'react-select';
import './AuditSelect.css';

export function AuditSelect(props: Props) {
  return (
    <Select
      classNamePrefix="audit-select"
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      {...props}
    />
  );
}

export default AuditSelect;
